import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentLayout } from '../../../video-layout/functions.any';
import { getHideSelfView } from '../../../base/settings/functions.any';
import { isToolboxVisible } from '../../../toolbox/functions.web';
import { TOTAL_HEADER_HEIGHT, TOTAL_TOOLBAR_HEIGHT, VERTICAL_FILMSTRIP_MIN_HORIZONTAL_MARGIN } from '../../constants';
import { LAYOUTS } from '../../../video-layout/constants';
import { setVisibleRemoteParticipants } from '../../actions.any';
import { setFilmstripMode } from '../../../video-layout/actions.any';
const PagingFilmstrip = () => {
    const dispatch = useDispatch();
    const { remoteParticipants, tileViewMode, verticalViewDimensions } = useSelector((state) => state['features/filmstrip']);
    const { localScreenShare } = useSelector((state) => state['features/base/participants']);
    const currentLayout = useSelector((state) => getCurrentLayout(state));
    const disableSelfView = useSelector((state) => getHideSelfView(state));
    const _isToolboxVisible = useSelector((state) => isToolboxVisible(state));
    const { iAmRecorder } = useSelector((state) => state['features/base/config']);
    const getParticipantPage = () => {
        let localParticipantsCount = localScreenShare ? 2 : 1;
        if (disableSelfView)
            localParticipantsCount = 0;
        const thumbnailHeight = (verticalViewDimensions?.remote?.height || 1) + VERTICAL_FILMSTRIP_MIN_HORIZONTAL_MARGIN;
        const localHeight = thumbnailHeight * localParticipantsCount;
        const filmstripHeight = window.innerHeight - (_isToolboxVisible ? (TOTAL_TOOLBAR_HEIGHT + TOTAL_HEADER_HEIGHT) : 0);
        let participantAvaiableCount = Math.floor((filmstripHeight - localHeight) / thumbnailHeight);
        let participantPage = participantAvaiableCount - 1;
        return participantPage;
    };
    useEffect(() => {
        if (currentLayout === LAYOUTS.VERTICAL_FILMSTRIP_VIEW && !Boolean(iAmRecorder) && !verticalViewDimensions.gridView?.gridDimensions) {
            const participantPage = getParticipantPage();
            dispatch(setFilmstripMode(participantPage));
            const first = participantPage + 1 === remoteParticipants.length ? participantPage : Math.min(participantPage - 1, remoteParticipants.length - 1);
            dispatch(setVisibleRemoteParticipants(0, first));
        }
        if (Boolean(iAmRecorder)) {
            dispatch(setFilmstripMode(Math.min(4, remoteParticipants.length)));
            dispatch(setVisibleRemoteParticipants(0, Math.min(4, remoteParticipants.length) - 1));
        }
    }, [tileViewMode, currentLayout, verticalViewDimensions.remoteVideosContainer?.height, remoteParticipants.length, disableSelfView, localScreenShare]);
    return (React.createElement(React.Fragment, null));
};
export default PagingFilmstrip;
